























































import Vue from 'vue';
import RecentItem from '@/components/RecentItems/RecentItem.vue';

export default Vue.extend({
  name: 'RecentNewsBox',
  data: () => ({
    noItemsText: 'Keine neuen Ankündigungen',
    newItemsCount: 2,
    header: 'Ankündigungen',
  }),
  components: {
    RecentItem,
  },
  props: {},
  computed: {
    news: {
      get(): Record<string, any> {
        return this.$store.getters.getAllNewsFeedEntry;
      },
    },
    newNews: {
      get(): Record<string, any> {
        return this.getNewNews();
      },
    },
    lastSignIn: {
      get(): number {
        return this.$store.getters.getUserLastSignIn;
      },
    },
  },
  methods: {
    displayNewsItem(id: string) {
      this.$router.push(`/news/${id}`);
    },
    getNewNews(): Record<string, any> {
      const newNews: Record<string, any> = {};
      const now = new Date();
      now.setDate(now.getDate() - 3);
      Object.entries(this.news).forEach((value) => {
        if (value[1].visibleFromUnix > now) {
          // eslint-disable-next-line prefer-destructuring
          newNews[value[0]] = value[1];
        }
      });
      return newNews;
    },
    goToNews() {
      this.$router.push('/news');
    },
  },
});
